import { create } from 'zustand';
import {
  knowledgeFleetApi,
  type LineageNode,
  type ResearchChain,
} from '@/services/api';

interface LineageFilters {
  clientId: string;
}

interface LineageState {
  roots: LineageNode[];
  selectedRoot: LineageNode | null;
  chain: ResearchChain | null;
  filters: LineageFilters;

  loading: boolean;
  chainLoading: boolean;
  error: string | null;

  setFilters: (filters: Partial<LineageFilters>) => void;
  selectRoot: (root: LineageNode | null) => void;
  fetchRoots: () => Promise<void>;
  fetchChain: (rootId: string) => Promise<void>;
}

export const useLineageStore = create<LineageState>((set, get) => ({
  roots: [],
  selectedRoot: null,
  chain: null,
  filters: { clientId: '' },

  loading: false,
  chainLoading: false,
  error: null,

  setFilters: (partial) => {
    set((s) => ({ filters: { ...s.filters, ...partial } }));
    get().fetchRoots();
  },

  selectRoot: (root) => {
    set({ selectedRoot: root, chain: null });
    if (root) {
      get().fetchChain(root.id);
    }
  },

  fetchRoots: async () => {
    const { filters } = get();
    set({ loading: true, error: null });
    try {
      const roots = await knowledgeFleetApi.listLineageRoots({
        client_id: filters.clientId || undefined,
        limit: 50,
      });
      set({ roots, loading: false });
    } catch (err) {
      set({ error: (err as Error).message, loading: false });
    }
  },

  fetchChain: async (rootId) => {
    set({ chainLoading: true });
    try {
      const chain = await knowledgeFleetApi.getLineageChain(rootId);
      set({ chain, selectedRoot: chain.root, chainLoading: false });
    } catch (err) {
      set({ error: (err as Error).message, chainLoading: false });
    }
  },
}));
